import { Info } from "lucide-react";
import { Tooltip } from "@fluentui/react-components";
import styles from "../../styles/portfolioManagerDashboard.module.scss";

function KpiInfoIcon({ content, inline = false }) {
  if (!content) return null;
  return (
    <Tooltip content={content} relationship="description" positioning="above" withArrow>
      <span
        className={inline ? styles.kpiInfoIconInline : styles.kpiInfoIcon}
        tabIndex={0}
        onClick={(e) => e.stopPropagation()}
        data-report-hide="true"
      >
        <Info size={inline ? 11 : 13} />
      </span>
    </Tooltip>
  );
}

export default KpiInfoIcon;
